
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ControlObjectivesOfType2DiabetesInChina',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ControlObjectivesOfType2DiabetesInChina.vue